import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IMeterEnrollmentStatusFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const MeterEnrollmentStatusFilterSelect: React.FC<IMeterEnrollmentStatusFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 300,
    disabled = false,
    options,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable
            loading={false}
            searchable={false}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
